import routerOptions0 from "/var/www/starvly/releases/20260930-211419/starvly-platform/node_modules/.pnpm/nuxt@4.1.2_@capacitor+preferences@6.0.4_@capacitor+core@6.2.2__@emnapi+core@1.10.0_@emn_af3bb60d3e9f5556b14dc4dc778c8b92/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}